import { renderReactIcon } from "./renderReactIcons";

export const productFeaturesListItems = (page) => {
  const list = page.map(item => {
    const Icon = renderReactIcon(item.icon.name);
    return {
      icon: Icon,
      title: item.name,
      description: item?.description
    }
  })
  return list;
}